import { configureStore, combineReducers } from '@reduxjs/toolkit'

import {
  AUTH_FEATURE_KEY,
  DEVELOPMENTS_FEATURE_KEY,
  authReducer,
  api,
  authApi,
  REVIEWS_FEATURE_KEY,
  reviewsReducer,
  developmentsReducer,
  widgetsReducer,
  WIDGETS_FEATURE_KEY,
  companiesReducer,
  COMPANIES_FEATURE_KEY,
  statisticsReducer,
  STATISTICS_FEATURE_KEY,
  mediaReducer,
  MEDIA_FEATURE_KEY,
  guidesReducer,
  GUIDES_FEATURE_KEY,
  resReducer,
  RES_FEATURE_KEY,
  USERS_FEATURE_KEY,
  usersReducer,
} from '@homeviews/store'

const combinedReducer = combineReducers({
  [api.reducerPath]: api.reducer,
  [authApi.reducerPath]: authApi.reducer,
  [REVIEWS_FEATURE_KEY]: reviewsReducer,
  [DEVELOPMENTS_FEATURE_KEY]: developmentsReducer,
  [AUTH_FEATURE_KEY]: authReducer,
  [WIDGETS_FEATURE_KEY]: widgetsReducer,
  [STATISTICS_FEATURE_KEY]: statisticsReducer,
  [MEDIA_FEATURE_KEY]: mediaReducer,
  [GUIDES_FEATURE_KEY]: guidesReducer,
  [RES_FEATURE_KEY]: resReducer,
  [USERS_FEATURE_KEY]: usersReducer,
  [COMPANIES_FEATURE_KEY]: companiesReducer,
})

const rootReducer = (state, action) => {
  // Clear store is user logout
  if (action.type === 'auth/logout') {
    state = undefined
  }
  return combinedReducer(state, action)
}

export const store = configureStore({
  reducer: rootReducer,
  // Additional middleware can be passed to this array
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(api.middleware),
  devTools: process.env.NODE_ENV !== 'production',
  // Optional Redux store enhancers
  enhancers: [],
})
